import { get } from 'lodash';
import bookingStateSelector from '../selectors/BookingStateSelector';
import initialBookingStateSelector from '../selectors/InitialBookingStateSelector';

export const getDoctorCardProps = (storeState) => {
    const bookingState = bookingStateSelector(storeState);

    // this will not change during the booking flow, so just use the initial value
    const { locationTimeZoneId } = initialBookingStateSelector(storeState);

    return {
        appointmentTime: get(bookingState, 'appointment_time'),
        locationId: get(bookingState, 'location_id'),
        locationTimeZoneId,
        procedureId: get(bookingState, 'visit_reason'),
        providerId: get(bookingState, 'provider_id'),
    };
};
